import {Directive, ElementRef, EventEmitter, HostBinding, HostListener, Output} from '@angular/core';
import {FocusableOption} from '@angular/cdk/a11y';

@Directive({
  selector: '[myupdatesFocusableTableItem]',
  standalone: true
})
export class FocusableTableItemDirective implements FocusableOption {
  @HostBinding('attr.tabindex') tabIndexAttr: number = -1;
  @Output() linkFocused = new EventEmitter<FocusableTableItemDirective>();

  constructor(private el: ElementRef<HTMLElement>) {}

  get element(): HTMLElement {
    return this.el.nativeElement;
  }

  focus(): void {
    this.el.nativeElement.focus();
  }

  setActive(isActive: boolean): void {
    this.tabIndexAttr = isActive ? 0 : -1;
  }

  @HostListener('focus')
  onFocus(): void {
    this.linkFocused.emit(this);
  }
}

